interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) pages.push(i);

  return (
    <div className="flex items-center justify-center gap-2 mt-10 flex-wrap">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-600 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line" />
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`w-9 h-9 flex items-center justify-center rounded-md text-sm transition-colors cursor-pointer ${
            page === current
              ? "bg-primary-600 text-background-50"
              : "border border-background-300 text-foreground-600 hover:bg-primary-50 hover:text-primary-700"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-600 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}